module.exports = __webpack_public_path__ + "static/media/up-arrow.12554e35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/up-arrow.svg
// module id = 907
// module chunks = 0